import get from 'lodash/get';
import { getUserFullName, getUserFullNameWithMiddleName } from 'modules/user/utils/user';

export const getName = (user, options = {}) => {
  if (!user) return undefined;

  if (!user.firstName && !user.lastName) return 'Anonymous';

  const { withMiddleName } = options;

  const title = get(user, 'title', '');
  const firstName = get(user, 'firstName', '');
  const lastName = get(user, 'lastName', '');

  if (withMiddleName) {
    const middleName = get(user, 'middleName', '');

    return getUserFullNameWithMiddleName({ title, firstName, middleName, lastName });
  }

  return getUserFullName({ title, firstName, lastName });
};

const genderIconNameMap = {
  female: 'female-avatar',
  male: 'male-avatar',
  other: 'gender-other',
  unknown: 'gender-unknown',
};

const genderDetailsMap = {
  female: {
    iconName: 'female',
    title: {
      id: 'Gender.Female',
      defaultMessage: '** Female',
    },
  },
  male: {
    iconName: 'male',
    title: {
      id: 'Gender.Male',
      defaultMessage: '** Male',
    },
  },
  other: {
    iconName: 'gender-other',
    title: {
      id: 'Gender.Other',
      defaultMessage: '** Other',
    },
  },
  unknown: {
    iconName: 'gender-unknown',
    title: {
      id: 'Gender.Unknown',
      defaultMessage: '** Unknown',
    },
  },
};

export const getGender = (user) => (user && user.gender) ? user.gender.toLowerCase() : 'unknown';
export const getGenderIconName = (gender) => genderIconNameMap[gender ? gender.toLowerCase() : 'unknown'];
export const getGenderDetails = (gender) => genderDetailsMap[gender ? gender.toLowerCase() : 'unknown'];
export const getPatientGender = (state) => getGender(state.auth.userInfo);
